import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper';
import { toast } from 'react-toastify';
import spaceService from '../../../redux/services/space.service';

export default function EditSelectedImageVideoUploadSlider({
    spaceId,
    selectedImageVideoPreviews,
    setSelectedImageVideoPreviews,
    formData,
    setFormData,
    removeMedia,
    setRemoveMedia,
    isDisabledEverything,
}) {
    const handleDelete = async (file, index) => {
        if (isDisabledEverything) return;

        const isBlob = file.blobUrl && file.blobUrl.startsWith('blob:');

        // If it's an existing file on the server and spaceId exists, delete from server immediately
        if (!isBlob && spaceId) {
            const confirmed = window.confirm('Are you sure you want to delete this media?');
            if (!confirmed) return;

            try {
                const res = await spaceService.deleteSpaceMedia(spaceId, file.name);
                if (res?.data?.status === 'success' || res?.status === 200) {
                    toast.success('Media deleted successfully');
                    setSelectedImageVideoPreviews((prev) =>
                        prev.filter((e) => e.blobUrl !== file.blobUrl && e.name !== file.name)
                    );
                    setRemoveMedia((prev) => prev.filter((name) => name !== file.name));
                    setFormData((prev) => ({
                        ...prev,
                        primaryImage: prev.primaryImage === file.name ? null : prev.primaryImage,
                    }));
                    return;
                } else {
                    toast.error(res?.data?.message || 'Failed to delete media');
                    return;
                }
            } catch (err) {
                console.error('Error deleting media:', err);
                toast.error(err?.response?.data?.message || 'Failed to delete media');
                return;
            }
        }

        // Newly added file (blob: URL, not yet uploaded to server)
        setSelectedImageVideoPreviews((prev) =>
            prev.filter((_, i) => i !== index)
        );

        if (!isBlob) {
            setRemoveMedia((prev) => [...prev, file.name]);
        }

        if (formData?.spaceMedia && formData?.spaceMedia?.length > 0) {
            let deleteCount = 0;
            const spaceMediaArr = [];
            for (let i = 0; i < formData.spaceMedia.length; i++) {
                const element = formData.spaceMedia[i];
                if (element.name === file.name && deleteCount === 0) {
                    deleteCount = 1;
                    continue;
                }
                spaceMediaArr.push(element);
            }
            setFormData((prev) => ({ ...prev, spaceMedia: spaceMediaArr }));
        }
    };

    return (
        <div className="c-uploadimage-slide">
            <div className="c-uploadimage-slide-prev"></div>
            <Swiper
                slidesPerView={4}
                navigation={{
                    nextEl: '.c-uploadimage-slide-next',
                    prevEl: '.c-uploadimage-slide-prev',
                    clickable: true
                }}
                modules={[Navigation]}
            >
                {selectedImageVideoPreviews.map((file, index) => {
                    const isImage =
                        file.type === 'image' ||
                        (typeof file.type === 'string' && file.type.startsWith('image/'));

                    if (isImage) {
                        return (
                            <SwiperSlide key={index}>
                                <div style={{ position: 'relative' }}>
                                    <img
                                        src={file.blobUrl}
                                        alt={file.blobUrl}
                                        style={{ height: 100, width: 100, borderRadius: 10, objectFit: 'cover' }}
                                        onClick={() => {
                                            if (isDisabledEverything) return;
                                            if (file.blobUrl && file.blobUrl.startsWith('blob:')) {
                                                toast.error('Please save the listing to set primary image');
                                                return;
                                            }
                                            setFormData((prev) => ({
                                                ...prev,
                                                primaryImage: file.name
                                            }));
                                        }}
                                    />
                                    {isDisabledEverything ? null : (
                                        <div
                                            className="cancel-button"
                                            onClick={() => handleDelete(file, index)}
                                        >
                                            <span>x</span>
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        );
                    } else {
                        return (
                            <SwiperSlide key={index}>
                                <div style={{ height: 100, width: 100, borderRadius: 10, background: '#e3e3e3', position: 'relative' }}>
                                    <video
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        src={file.blobUrl}
                                        autoPlay
                                        muted
                                    />
                                    {isDisabledEverything ? null : (
                                        <div
                                            className="cancel-button"
                                            onClick={() => handleDelete(file, index)}
                                        >
                                            <span>x</span>
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        );
                    }
                })}
            </Swiper>
            <div className="c-uploadimage-slide-next"></div>
        </div>
    );
}
